import { createGlobalStyle, ThemeProvider } from "styled-components";
import {
  Window,
  WindowHeader,
  WindowContent,
  Button,
  List,
  ListItem,
  Separator,
  styleReset,
} from "react95";
import original from "react95/dist/themes/original";
import ms_sans_serif from "react95/dist/fonts/ms_sans_serif.woff2";
import ms_sans_serif_bold from "react95/dist/fonts/ms_sans_serif_bold.woff2";

import logo from "./godsofnorrath2.png";

const GlobalStyles = createGlobalStyle`
  ${styleReset}
  @font-face {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif}') format('woff2');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'ms_sans_serif';
    src: url('${ms_sans_serif_bold}') format('woff2');
    font-weight: bold;
    font-style: normal;
  }
  body, input, select, textarea {
    font-family: 'ms_sans_serif';
  }
  body {
    background: #008080;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
  }
`;

const DOWNLOAD_URL =
  "https://github.com/atroche/eqemupatcher/releases/download/1.0.6.14/gods_of_norrath.exe";
const DISCORD_URL = "https://discord.gg/4TNFShXnpp";

export function App() {
  return (
    <ThemeProvider theme={original}>
      <GlobalStyles />
      <Window style={{ maxWidth: 600, width: "100%" }}>
        <WindowHeader
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "4px 8px",
          }}
        >
          <span style={{ fontWeight: "bold" }}>Gods of Norrath</span>
        </WindowHeader>
        <WindowContent
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 16,
          }}
        >
          <img
            src={logo}
            alt="Gods of Norrath"
            style={{
              maxWidth: 280,
              width: "100%",
              height: "auto",
              imageRendering: "auto",
            }}
          />

          <Separator />

          <div style={{ width: "100%" }}>
            <h3 style={{ marginTop: 0, marginBottom: 8 }}>Server Features:</h3>
            <List>
              <ListItem>
                🗡️ Powerful armor / weapon set bonuses — plenty to mix 'n' match
              </ListItem>
              <ListItem>🎒 Pet bags</ListItem>
              <ListItem>⛪ Deity-specific AAs and mechanics</ListItem>
              <ListItem>🎫 Pre-50 AAs via dropped tokens</ListItem>
              <ListItem>📜 Revamped newbie quests</ListItem>
              <ListItem>💿 ROF2 client</ListItem>
              <ListItem>🚫 No Plane of Knowledge</ListItem>
            </List>
          </div>

          <Separator />

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 12,
              padding: "8px 0",
            }}
          >
            <p style={{ margin: 0, textAlign: "center" }}>
              Ready to begin your adventure?
            </p>
            <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
              <Button
                primary
                size="lg"
                onClick={() => window.open(DOWNLOAD_URL, "_blank")}
                style={{ fontWeight: "bold" }}
              >
                📥 Download Patcher
              </Button>
              <Button
                size="lg"
                onClick={() => window.open(DISCORD_URL, "_blank")}
                style={{ fontWeight: "bold" }}
              >
                💬 Join Discord
              </Button>
            </div>
            <p
              style={{
                margin: 0,
                fontSize: 12,
                color: "#666",
                textAlign: "center",
              }}
            >
              Run the patcher to download game files and connect to the server
            </p>
          </div>
        </WindowContent>
      </Window>
    </ThemeProvider>
  );
}

export default App;
